var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg-icon',{staticClass:"screenfull-svg",attrs:{"icon-class":_vm.isFullscreen?'quit_full_screen':'full_screen'},nativeOn:{"click":function($event){return _vm.click($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }